import { initializeApp, FirebaseApp } from "firebase/app";
import { getFirestore, Firestore } from "firebase/firestore";
import { getAuth, Auth } from "firebase/auth";
import { getFunctions, Functions } from "firebase/functions";
import { isAdminDomain } from "../domain";

const firebaseConfig = {
  apiKey: "AIzaSyDgGyOGeKLqOYGl-JdSla_bm0ZxuJV5ORI",
  authDomain: "payattable-c0e8c.firebaseapp.com",
  projectId: "payattable-c0e8c",
  storageBucket: "payattable-c0e8c.firebasestorage.app",
  messagingSenderId: "806377543591",
  appId: "1:806377543591:web:76e47e485b89e190b40882"
};

const app: FirebaseApp = initializeApp(firebaseConfig);
const db: Firestore = getFirestore(app);
// Only initialize Firebase Auth on the admin domain so the payment app never loads the admin session.
const auth: Auth | null = isAdminDomain ? getAuth(app) : null;
// Explicit region so callable URLs resolve to us-central1 (must match deployed functions)
const functions: Functions = getFunctions(app, 'us-central1');

// Production mode: All API calls go to Cloud Functions
// No emulator connections - use REACT_APP_API_BASE_URL env var for custom endpoints

export { db, auth, functions };
export default app;